import { useCallback } from 'react'
import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'

import { WarningTriangle } from '@/icons'
import { ModalHeader } from '@/components/Modal'

import { useTexts } from '../hooks/useTexts'
import { useController } from '../hooks/useController'

export function InvalidHeader() {
  const texts = useTexts()
  const {
    status,
    close,
    data: { initiallySelectedRoutes },
  } = useController()

  const initiallySelectedRoutesCount = initiallySelectedRoutes.length

  const getTitle = useCallback(() => {
    switch (status) {
      case 'invalidForEmptyRoutes':
        return texts.invalidDataRoutesEmptyHeaderTitle(initiallySelectedRoutesCount)
      case 'invalidForSimulationEnvironment':
        return texts.title(initiallySelectedRoutesCount)
      default:
        return ''
    }
  }, [status, texts, initiallySelectedRoutesCount])

  return (
    <ModalHeader
      title={getTitle()}
      avatar={<WarningTriangle color="$pureWhite" background="$nightRider" size={18} />}
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={close} label="" />]}
    />
  )
}
